import $ from 'jquery';
import 'jquery.mmenu';
$(document).ready(function( $ ) {
  $("#js-mobile-menu").mmenu();
});